import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import axios from 'axios'

Vue.config.productionTip = false

const url = process.env.VUE_APP_HOME;

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (401 === error.response.status) {
      
      localStorage.clear();
      //var token = JSON.parse(localStorage.getItem('scientia-session-authorization')); 
      window.location = url;
    
  } else {
      return Promise.reject(error);
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
